<style scoped>
.mu-input {
  padding-bottom: 0px;
  margin-bottom: 0px;
  min-height: 0px;
  font-size: 12px;
  width: auto;
}
.focus-text {
  font-size: 24px;
}
.table-empty {
  text-align: center;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<template>
  <div v-loading="loading">
    <mu-button
      icon
      class="float-right"
      @click="$emit('close')"
      >
      <mu-icon value="close" />
    </mu-button>
    <mu-card-text>
      <h2>{{$t('AnalyticsReaction.title')}}</h2>
    </mu-card-text>
    <div v-if="reactions.length > 0 && media">
      <chart :option="chartOption" id="AnalyticsReactionMedia" height="300px" />
      <mu-card-text>
        <mu-select v-model="interval">
          <mu-option v-for="(option, index) in optionsIntervals" :key="index" :label="option.text" :value="option.value"></mu-option>
        </mu-select>
      </mu-card-text>
    </div>
    <small v-if="tags.length === 0" style="margin: 16px;">
      {{$t('AnalyticsReaction.noTags')}}
    </small>
  </div>
</template>

<script>
import axios from "axios";

import theme from '@/mixins/theme.js'
import timeFormatter from '@/utils/timeFormatter.js'

import chart from '@/components/Charts/Charts.vue'
import echarts from 'echarts'

import langEn from './lang/en.json'
import langZh from './lang/zh.json'

export default {
  name: 'AnalyticsReaction',
  props: ["channel", "media"],
  mixins: [theme],
  components: {
    chart,
  },
  data() {
    return {
      reactions: [],
      tags: [],
      loading: false,
      
      interval: 3,
    };
  },
  watch: {
  },
  computed: {
    intervals() {
      return [1, 2, 3, 5, 10, 20, 30, 60];
    },
    optionsIntervals() {
      return this.intervals.map(d => {
        return { text: this.$t('AnalyticsReaction.intervals.display', { num: d }), value: d }
      });
    },
    timeline() {
      return Array.from(Array(Math.round(((this.media ? this.media.duration : 0) + 1) / this.interval)).keys()).map(i => timeFormatter(i * this.interval));
    },
    computedTags() {
      return this.tags.map(tag => tag.name);
    },
    computedData() {
      var data = [];
      this.reactions.forEach(reaction => {
        var index = this.tags.findIndex(tag => tag._id === reaction.tag_id);
        if(index !== -1) {
          var timestamp = Math.round(reaction.timestamp / this.interval);
          var found = data.findIndex(row => row[0] === timestamp && row[1] === index);
          if(found == -1) {
            data.push([timestamp, index, 1]);
          } else {
            var temp = data[found];
            temp[2]++;
            data.splice[found, 1, temp];
          }
        }
      });
      return data;
    },
    maxData() {
      var max = 0;
      this.computedData.forEach(i => {
        if(i[2] > max) {
          max = i[2];
        }
      });
      return max;
    },
    chartOption() {
      return {
        tooltip: {
          position: 'top'
        },
        animation: false,
        grid: {
          height: '50%',
          y: '10%'
        },
        xAxis: {
          type: 'category',
          data: this.timeline,
          splitArea: {
            show: true
          }
        },
        yAxis: {
          type: 'category',
          data: this.computedTags,
          splitArea: {
            show: true
          }
        },
        dataZoom: [
          {
            type: 'slider',
            show: true,
            xAxisIndex: [0],
          },
          {
            type: 'slider',
            show: true,
            yAxisIndex: [0],
            left: '93%',
          },
          {
            type: 'inside',
            xAxisIndex: [0],
          },
          {
            type: 'inside',
            yAxisIndex: [0],
          }
        ],
        visualMap: {
          min: 0,
          max: this.maxData,
          calculable: true,
          orient: 'horizontal',
          left: 'center',
          bottom: '15%'
        },
        series: [{
          name: this.$t('AnalyticsReaction.clicks'),
          type: 'heatmap',
          data: this.computedData,
          label: {
            normal: {
              show: true
            }
          },
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
    },
  },
  mounted() {
    this.getData(this.media._id);
  },
  created() {
    this.$i18n.add('en', langEn); // Add English Translation
    this.$i18n.add('zh', langZh); // Add Traditional Chinese Translation
  },
  methods: {
    getData(mediaId) {
      this.loading = true;
      axios.get(this.$store.getters.urlApi + "reaction/media/" + mediaId + "/tag/list?filter=all", {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.reactions = response.data.data.reactions;
        this.fetchTags(mediaId);
      });
    },
    fetchTags(mediaId) {
      axios.get(this.$store.getters.urlApi + "tag/media/" + mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        if(response.data.data.tags)
          this.tags = response.data.data.tags;
        this.loading = false;
      });
    },
  },
};
</script>
